import {
  Box,
  Alert,
  CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import ShowcaseCreationSection from '../showcase/ShowcaseCreationSection';

interface ShowcaseStepProps {
  stylistId?: string;
  onShowcaseCountChange: (count: number) => void;
  isLoading?: boolean;
}

const ShowcaseStep: React.FC<ShowcaseStepProps> = ({
  stylistId,
  onShowcaseCountChange,
  isLoading
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 2 }}>
      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
          <CircularProgress />
        </Box>
      )}

      {stylistId ? (
        <ShowcaseCreationSection
          stylistId={stylistId}
          onShowcaseCountChange={onShowcaseCountChange}
        />
      ) : (
        <Alert severity="error">
          {t('quickListingWizard.stylistIdMissing')}
        </Alert>
      )}
    </Box>
  );
};

export default ShowcaseStep;
